import { createSlice } from '@reduxjs/toolkit';

export const counterSlice = createSlice({
  name: 'prompt',
  initialState: {
    prompt: '',
    originalUserPrompt: ''
  },
  reducers: {
    setPrompt: (state, action) => {
      state.prompt = action.payload;
    },
    setOriginalUserPrompt: (state, action) => {
      state.originalUserPrompt = action.payload;
    }
  }
});

export const { setPrompt, setOriginalUserPrompt } = counterSlice.actions;

export default counterSlice.reducer;
